import CompareField from "@/components/Form/Fields/CompareField";
import { FV } from "@/components/Form/Validation/FormValidators";
import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import ActivitySelect, {
  ASSET_CONFIGS,
} from "@/modules/activity-components/ActivitySelect";
import InvoiceStruct from "@/redux/actions/struct/implemented/InvoiceStruct";
import { FieldState } from "final-form";
import { Invoice } from "../../../RAInterfaces";

interface RAInvoiceActivityFieldProps {
  ignoreCompare?: boolean;
  prefix?: string;
  disableAll?: boolean;
  invoiceType: string;
  invoice: Invoice;
  entity: string;
}
const RAInvoiceActivityField = (props: RAInvoiceActivityFieldProps) => {
  const relevantActivityTypes =
    InvoiceStruct.getRelevantActivitiesFor(props.invoiceType) || [];

  const ignoreRelevantActivityTypeValidator =
    props.invoice.data.status === "init";

  const activityTypeValidator =
    ignoreRelevantActivityTypeValidator || relevantActivityTypes.length === 0
      ? null
      : (
          value: { assetId: string; assetType: string }[],
          allValues: object,
          meta?: FieldState<{ assetId: string; assetType: string }[]>
        ) => {
          if (
            value?.filter((e) => relevantActivityTypes.includes(e.assetType))
              .length === 0
          ) {
            return i18n.t(
              "ra:InvoiceForm.activityTypeRequired",
              "Es muss mindestens eine Aktivität der folgenden Typen ausgewählt werden:\n{{types}}",
              {
                types: relevantActivityTypes
                  .map((type) => ASSET_CONFIGS()[type]?.label || "-")
                  .join(", "),
              }
            );
          }
        };

  return (
    <CompareField
      ignoreCompare={props.ignoreCompare}
      name={`${props.prefix || ""}activity`}
      validate={FV.compose(activityTypeValidator)}
      isEqual={(a, b) => {
        return _.isEqual(a, b);
      }}
      // validate={FormValidators.compose(
      //   FormValidators.required(),
      //   FormValidators.min(1)
      // )}
    >
      {({ input, meta }) => (
        <ActivitySelect
          showJump
          disabled={props.disableAll}
          label={
            i18n.t(
              "acc:AccountingBookingForm.connectAsset",
              "Aktivität verknüpfen"
            ) + (Boolean(activityTypeValidator) ? "*" : "")
          }
          className={`accounting-form-assignment`}
          multiple={true}
          {...FV.getValidation(meta)}
          block
          appearance="bf"
          businessUnits={[props.invoice.data.type]}
          identifier="invoice-form-connect-activities"
          value={input.value || []}
          onChange={input.onChange}
          entityId={props.entity}
          // onValueAdded={async (value) => {
          //   await InvoiceService.addActivity(props.asset._id, value);
          // }}
          // onValueRemoved={async (value) => {
          //   await InvoiceService.removeActivity(props.asset._id, value);
          // }}
          cleanable
          // label={RA}
          assets={[
            AssetTypes.Activity.DamageClaim,
            AssetTypes.Activity.Project,
            AssetTypes.ActivityRelated.ProjectDeprecated,
            AssetTypes.Activity.Maintenance,
            AssetTypes.Activity.OrderingProcess,
            AssetTypes.Activity.SupplyContract,
            AssetTypes.Activity.Insurance,
            AssetTypes.Activity.InvoiceFollowUp,
          ]}
        />
      )}
    </CompareField>
  );
};

export default RAInvoiceActivityField;
